import React, { useState, useEffect } from "react";
import {
  useOutletContext,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import ChatSidebar from "../components/chat/ChatSidebar";
import ChatWindow from "../components/chat/ChatWindow";
import OperatorSetupModal from "../components/modals/OperatorSetupModal";

const ChatLayout = () => {
  const [showOperatorModal, setShowOperatorModal] = useState(false);
  const [isSavingOperator, setIsSavingOperator] = useState(false);

  // Get URL parameters and navigation
  const { chatId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedChatId = chatId ? parseInt(chatId) : null;

  // Get toggleSidebar function from AdminLayout context
  const context = useOutletContext();
  const toggleSidebar = context?.toggleSidebar;

  // Check operator setup on mount
  useEffect(() => {
    const operatorName = localStorage.getItem("operatorName");
    if (!operatorName) {
      setShowOperatorModal(true);
    }
  }, []);

  const handleChatSelect = (chatId) => {
    // Navigate to chat detail page while preserving query params
    console.log("🔄 [Navigation] Preserving query params:", location.search);
    navigate(`/admin/chats/${chatId}${location.search}`);
  };

  const handleBackToList = () => {
    // Navigate back to chat list while preserving query params
    console.log(
      "🔄 [Navigation] Back to list with query params:",
      location.search
    );
    navigate(`/admin/chats${location.search}`);
  };

  const handleOperatorSave = async (operatorName) => {
    setIsSavingOperator(true);
    try {
      // localStorage is already set in the modal component
      console.log("✅ Operator name saved:", operatorName);
      setShowOperatorModal(false);
    } catch (error) {
      console.error("Error saving operator:", error);
    } finally {
      setIsSavingOperator(false);
    }
  };

  return (
    <div className="h-screen-dynamic bg-gray-100 dark:bg-gray-900">
      {/* Main Chat Container - WhatsApp Style */}
      <div className="h-full flex overflow-hidden">
        {/* Sidebar - hidden on mobile when chat is selected */}
        <div
          className={`${selectedChatId ? "hidden lg:flex" : "flex"} min-w-0`}
        >
          <ChatSidebar
            selectedChatId={selectedChatId}
            onChatSelect={handleChatSelect}
            onToggleSidebar={toggleSidebar}
          />
        </div>

        {/* Chat Window - full width on mobile when selected */}
        <div className={`${selectedChatId ? "flex" : "hidden lg:flex"} flex-1`}>
          <ChatWindow
            selectedChatId={selectedChatId}
            onBackToList={handleBackToList}
          />
        </div>
      </div>

      {/* Operator Setup Modal */}
      <OperatorSetupModal
        isOpen={showOperatorModal}
        onSave={handleOperatorSave}
        isSaving={isSavingOperator}
      />
    </div>
  );
};

export default ChatLayout;
